import InfoButton from "@/components/Selection/component/InfoButton/InfoButton";
import Item from "@/components/Selection/component/Item/Item";

import classes from "./Block.module.css";
import Vues from "@/js/Vues";
import { observer } from "mobx-react-lite";
import AppState from "@/js/AppState";
import { STATUS } from "@/js/SelectionPhase";
import { useEffect } from "react";
import Draggable from "../Item/Draggable";

const Block = ({ index, block }) => {
    let style = {}

    if(block.status === STATUS.open) {
        style.backgroundColor = block.borderColor
    }

    return (
      <div className={`${classes.Block} ${classes[block.status]}`} style={style}>
        {/* <div key={`Block${index}`} className={`${classes.Block} ${hasSelectedItemInBlock(block) ? null : classes.inactive} ${block.locked ? null : classes.locked}`}> */}

        { block.status === STATUS.open &&
        <div  className={`${classes.BlockTitle}`} >
          <InfoButton className={classes.BlockInfoBtn} block={block} />
          <h1  className={ classes.title } >{block.title}</h1>
        </div> }

        <div className={classes.ItemList}>
          {block.items.map(item => {
            let disabled = !item.done || item.selected || !item.blockRef.draggable

            if(disabled) return <Item key={item.id} item={item} isInBlock={true} />


            return (
              <Draggable key={item.id} id={item.id}>
                <Item item={item} isInBlock={true} />
              </Draggable>
            )
          })}
        </div>

        {/* { AppState.debugMode && <div className={classes.Debug}>{block.status}</div> } */}
      </div>
    )
}

export default observer(Block);